import axios from "axios"
import {langControl} from "@/scripts/istore-ui-lang"
import iStoreApi from "@/scripts/istore-api.js"
import iStoreSetting from "@/scripts/istore-setting.js"
import iStoreUtils from "@/scripts/istore-utils.js"
import $store from "@/store/index.js"


export default {
  iStoreUIDB: 'istoreui',
  trackingDB: 'trackingmonitor',
  imanagerPluginTokenKey: iStoreUtils.encode(`imanager.plugin.tokens`),
  async load() {
    console.log('#[AppFrame] Loaded %s, obj:%O', $store.state.currentMenu.name, $store.state.currentMenu)
  },
  getToken() {
    return iStoreApi.getToken()
  },
  /**
   *
   * @param request
   * @param plugin
   * @returns boolean
   */
  async preparePlugin(request, plugin) {
        
    let {functions, databases, languages, roles} = request
    let newFunction = []

    console.debug("#[preparePlugin] functions:", functions?.length)
    console.debug("#[preparePlugin] languages:", languages?.length)
    console.debug("#[preparePlugin] roles:", roles?.length)

    if (functions && typeof functions === 'object' && plugin.pluginId) {
      
      if (databases) {
        
        // TODO : MOVE GENERATE ISTORE DB IN IMANAGER INIT
        databases.push({"name" :this.trackingDB, "token" : ""})
        for (let database of databases) {
          await iStoreApi.createDB(database.name, database.token)
        }
      }
      
      const pushData = []
      for (let func of functions) {
        if (func && typeof func === 'object') {
          // If "pluginId" key is not found in plugin's function JSON file, then use the "pluginId" from plugin arg
          // To keep "pluginId" consistent, please always provide it in each JSON file.
          // For example, on QI plugin, we use "/orion-quality-inspection" as its plugin ID
          // Then, we need to put this `"pluginId": "/orion-quality-inspection"` in all JSON in plugin's ./src/init/functions/
          if (!func['pluginId']) {
            func['pluginId'] = plugin.pluginId
          }

          pushData.push({
            key: `istoreui.func.${func.parent}.${func.module}.${func.name}`,
            value: JSON.stringify(func)
          })
          newFunction.push(`${func.module}.${func.name}`)
        }
      }
      // Delete all of func for plugin
      const conditions = {
        condition: [{
          column: "pluginId",
          condition: "=",
          value: plugin.pluginId
        }]
      }
      const rs = await iStoreApi.searchKeyPrefixAndCondition("istoreui", "istoreui.func.", conditions)
      
      if (rs.length) {
        //let keys = []
        for (let r of rs) {
          //keys.push(r.key)
          await iStoreApi.delete("istoreui", r.key)
        }
      }
      
      await this._createFunction(pushData)
      
      if (languages && languages.length) {
        await this.updateBatch({db: "language", dataList: languages})
      }
      
      if (roles && roles.length) {
        
        const result = await iStoreApi.searchKeyPrefix("istoreui","istoreui.role.")
        // const list_key = roles.map(role => role.key)
        // const result = await this.searchKeyMultiple({
        //     db: "istoreui",
        //     keys: list_key
        // });
        
        for (let index = 0; index < result.length; index++) {
          if (roles.some(item => item.key === result[index].key)) {
            const tempFunctions = (result[index].value.functions);
            const tempRole = JSON.parse(roles.find(item => item.key === result[index].key).value)
            
            for (let x = 0; x < tempRole.functions.length; x++) {
              const func = tempRole.functions[x];
              const hasMatch = tempFunctions.includes(func)
              if (!hasMatch) {
                result[index].value.functions.push(func)
              }
            }
            
            for (const key in tempRole.functionPermission) {
              const element = tempRole.functionPermission[key];
              if (!result[index].value.functionPermission) {
                result[index].value.functionPermission = {}
              }
              result[index].value.functionPermission[key] = {}
              result[index].value.functionPermission[key] = element
            }
          }
          else{

            const tempFunctions = result[index].value.functions;
            
            for (let x = tempFunctions.length - 1; x >= 0 ; x--) {
              const element = tempFunctions[x];
              if (newFunction.includes(element)) {
                const indexEl = result[index].value.functions.indexOf(element);
                if (indexEl !== -1) {
                  result[index].value.functions.splice(indexEl, 1);
                }
              }
            }
          }
        }
        const stringify_result = result.map(item => ({
          ...item,
          value: JSON.stringify(item.value)
        }));
        
        await this.updateBatch({db: "istoreui", dataList: stringify_result})
      }

      window.top.postMessage({
        type: 'inner-iframe-loaded',
        payload: pushData
      }, '*')
      return "success"

    } else {
      console.warn("plugin.pluginId not found!, ", plugin)
    }
  },
  async goToLoginPage() {
    location.href = "/imanager"
    $store.dispatch("logOut")
  },
  async createTempFunction(request) {
    try {
      let {functions, isInit} = request;
      for (const func of functions) {
        const funcNode = func;
        funcNode.isTemp = true
        //await this._tempLanguage(funcNode)
        $store.commit('removeNode', funcNode)
        $store.commit('addNode', funcNode)
      }

      if (!isInit) {
        //   let tmp = functions[0].parent.split(".")
        //   console.debug("#[createTempFunction] tmp:", tmp)
        //$store.commit("openFolder", {key: tmp[tmp.length - 1], name: functions[0].name})
        $store.commit("openFolderTemp", functions)
      }
    } catch (error) {
      console.error("createTempFunction error: ", error)
    }
    window.top.postMessage({
      type: 'inner-iframe-loaded',
      payload: "create temp function"
    }, '*')
    return {}
  },
  async removeTempFunction(request) {
    try {
      let { functions } = request;
      for (const func of functions) {
        const funcNode = func;
        funcNode.isTemp = true
        //await this._tempLanguage(funcNode)
        $store.commit('removeNode', funcNode)
      }
      return true
    } catch(error) {
      console.error("removeTempFunction error: ", error)
    }
    return {}
  },
  async removeTempFunctions(request) {
    try {
      let { parentKey } = request;
      $store.commit('removeNodes', parentKey)
      return true
    } catch(error) {
      console.error("removeTempFunctions error: ", error)
    }
    return {}
  },
  // The function to change the highlight on active menu from plugin, and also redirect to specified menu
  async setCurrentMenu(request) {
    try {
      if (request.menu) {
        // Go to specified menu based on their 'parent', 'module', and 'name' keys
        const { parent, module, name } = request.menu
        const currentMenu = $store.state.loginUser.userFunctions.find(item => item.parent === parent && item.module === module && item.name === name)
        $store.commit('setCurrentMenu', currentMenu)
      } else {
        // Go to dashboard
        $store.commit('setCurrentMenu')
      }
    } catch (error) {
      console.error("setCurrentMenu error: ", error)
    }
    return {}
  },
  async getFunctionInfo() {
    try {
      return $store.state.currentMenu
    } catch (error) {
      console.error("getFunctionInfo error: ", error)
    }
    return {}
  },
  async getLoginUser(result) {
    try {
      result = Object.assign({}, $store.state.loginUser)
      delete result.pxd
      delete result.userFunctions
      return result;
    } catch (error) {
      console.error("getLoginUser error: ", error)
    }
    return {}
  },
  async getWatermarkUrl() {
    try {
      let result = $store.getters.getWatermarkUrl;
      return result;
    } catch (error) {
      console.error("getWatermarkUrl error: ", error)
    }
    return {}
  },
  async sendTrackingAction(request) {
    try  {
      const starNumber = request.starNumber;
      const plugin = request.pluginName;
      const uuid = iStoreUtils.generateTrackingUuid();
      const action = request.userAction;
      const data = request.data;

      const key = `orion.tracking.${starNumber}.${plugin}.${uuid}`;

      const value = {
          starNumber: starNumber,
          pluginName: plugin,
          action: action,
          data: data,
      };

      await this.update({
          db: this.trackingDB,
          data: { key: key, value: JSON.stringify(value) }
      });

      return "Tracking action updated successfully";
    } catch (error) {
      console.error("sendTrackingAction error: ", error)
    }
    return {}
  },
  async getTrackingAction(request) {
    try {  
      const starNumber = request.starNumber;
      var key = "";
      if(starNumber == ""){
        key = `orion.tracking.`;
      } else {
        key = `orion.tracking.${starNumber}`;
      }

      const data = await this.searchKeyPrefix({
          db: this.trackingDB,
          key: key
      });

      return data;
    } catch (error) {
      console.error("getTrackingAction error: ", error)
    }
    return {}
  },
  async paginate(request) {
    try {
      const {db, limit, offset} = request
      if (db && limit !== undefined && offset !== undefined) {
        //const { db, module, name } = $store.state.currentMenu
        const token = await iStoreApi.getToken()
        const result = await axios.get(`${iStoreSetting.iStoreUrl}/paginate/${db}/${limit}/${offset}`, {headers: {Token: token}})
        if (result.status === 200) {
          return result.data
        }
      }
    } catch (error) {
      console.error("paginate error: ", error)
    }
    return {}
  },
  async getIstoreUrl() {
    try {
      let result = iStoreSetting.iStoreUrl;
      return result;
    } catch (error) {
      console.error("getWatermarkUrl error: ", error)
    }
    return {}
  },
  async search(request) {
    try {
      let {db, key, limit, offset} = request
      let url
      if (limit !== undefined && offset !== undefined) {
        offset = limit * (offset - 1)
        url = `${iStoreSetting.iStoreUrl}/search/${db}/${key}/${limit}/${offset}`
      } else {
        url = `${iStoreSetting.iStoreUrl}/search/${db}/${key}`
      }
      const token = await iStoreApi.getToken()
      const result = await axios.get(url, {
        headers: {Token: token}
      })
      if (result.status === 200) {
        return result.data
      }
    } catch (error) {
      console.error("search error: ", error)
    }

    return {}
  },
  async searchKeyMultiple(request) {
    try {
      let {db, keys} = request

      const token = await iStoreApi.getToken()
      let url = `${iStoreSetting.iStoreUrl}/multiple/${db}`
      const result = await axios.post(url, keys, {
        headers: {Token: token},
      })
      if (result.data) {
        return result.data
      }
    } catch (error) {
      console.error("searchKeyMultiple error: ", error)
    }
    return {}
  },
  async searchKeyPrefix(request) {
    try {
      let {db, key, limit, offset} = request
      const token = await iStoreApi.getToken()
      let url
      if (limit !== undefined && offset !== undefined) {
        offset = limit * (offset - 1)
        url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${key}/${limit}/${offset}`
      } else {
        url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${key}`
      }
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      if (result.data) {
        return result.data
      }
    } catch (error) {
      console.error("searchKeyPrefix error: ", error)
    }
    return {}
  },
  async searchKeyPrefixCloud(request) {
    try {
      let {db, key, limit, offset} = request
      const token = await iStoreApi.getTokenCloud()
      let url
      if (limit !== undefined && offset !== undefined) {
        offset = limit * (offset - 1)
        url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${key}/${limit}/${offset}`
      } else {
        url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${key}`
      }
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      if (result.data) {
        return result.data
      }
    } catch (error) {
      console.error("searchKeyPrefix error: ", error)
    }
    return {}
  },
  async searchKeyPrefixCount(request) {
    try {
      const {db, key} = request
      const token = await iStoreApi.getToken()
      let url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${key}/count`
      const result = await axios.get(url, {
        headers: {Token: token},
      })

      if (result.data) {
        return parseInt(result.data.count)
      }
    } catch (error) {
      console.error("searchKeyPrefixCount error: ", error)
    }
    return 0
  },
  async searchKeyPrefixAndCondition(request) {
    try {
      const {db, key, conditions} = request
      const token = await iStoreApi.getToken()
      let url = `${iStoreSetting.iStoreUrl}/searchKeyPrefixAndCondition/${db}/${key}`
      const result = await axios.post(url, JSON.stringify(conditions), {
        headers: {Token: token},
      })
      if (result.data) {
        return result.data
      }
    } catch (error) {
      console.error("searchKeyPrefixAndCondition error: ", error)
    }
    return {}
  },
  async searchKeyPrefixAndConditionCount(request) {
    try {
      const {db, key, conditions} = request
      const token = await iStoreApi.getToken()
      let url = `${iStoreSetting.iStoreUrl}/searchKeyPrefixAndCondition/${db}/${key}/count`
      const result = await axios.post(url, JSON.stringify(conditions), {
        headers: {Token: token},
      })
      if (result.data) {
        return parseInt(result.data.count)
      }
    } catch (error) {
      console.error("searchKeyPrefixAndConditionCount error: ", error)
    }
    return 0
  },
  async getSelf() {
    try {
      const result = await iStoreApi.getSelf()
      return result
    } catch (error) {
      console.error("getSelf error: ", error)
    }
    return {}
  },
  async promptGPT(request){
    try {
      let {data} = request;
      const token = await iStoreApi.getToken()
      let url = `${iStoreSetting.iStoreUrl}/openai/prompt`
      const result = await axios.post(url, JSON.stringify(data), {
        headers: {Token: token},
      })
      if (result.data) {
        return result.data
      }

    } catch (error) {
      console.error("promptGPT error: ", error.response?.data.message)
    }
    return {}
  },
  async update(request) {
    try {
      let {db, data} = request;
      const token = await iStoreApi.getToken()
      const result = await axios.put(`${iStoreSetting.iStoreUrl}/${db}`, data, {headers: {Token: token}})

      if (result.data) {
        return result.data
      }

    } catch (error) {
      console.error("update error: ", error)
    }
    return {}
  },
  async updateBatch(request) {
    try {
      let {db, dataList} = request;
      const token = await iStoreApi.getToken()
      const url = `${iStoreSetting.iStoreUrl}/${db}/batch`
      const result = await axios.put(url, dataList, {
        headers: {Token: token},
      })
      if (result.data) {
        return result.data
      }
    } catch (error) {
      console.error("updateBatch error: ", error)
    }
    return {}
  },
  async delete(request) {
    try {
      let {db, key} = request
      const token = await this.getToken()
      const url = `${iStoreSetting.iStoreUrl}/${db}/${key}`
      const result = await axios.delete(url, {
        headers: {Token: token},
      })
      return result.data

    } catch (error) {
      console.error("delete error: ", error.response?.data.message)
    }
    return {}
  },
  async deleteBatch(request) {
    try {
      let {db, keys} = request
      const token = await this.getToken()
      const url = `${iStoreSetting.iStoreUrl}/${db}/batch`
      const result = await axios.delete(url, {
        data: keys,
        headers: { Token: token },
      })
      return result.data

    } catch (error) {
      console.error("deleteBatch error: ", error.response?.data.message)
    }
    return {}
  },
  async uploadFile(request){
    try {
      let {cid, userId, category, file} = request.data
      let fileObj = file
      if (file && file.data && Array.isArray(file.data)) {
        const blob = new Blob([new Uint8Array(file.data)], {
          type: file.type || "application/octet-stream",
        })
        if (file.name) {
          fileObj = new File([blob], file.name, { type: blob.type })
        } else {
          fileObj = blob
        }
      }
      
      const formData = new FormData()
      formData.append('cid', cid)
      formData.append('userId', userId)
      formData.append('category', category)
      if (fileObj) {
        if (fileObj instanceof Blob && !(fileObj instanceof File)) {
          formData.append('file', fileObj, file?.name || 'upload.bin')
        } else {
          formData.append('file', fileObj)
        }
      }
      const token = await this.getToken()
      const url = `${iStoreSetting.iStoreUrl}/file/upload`
      const result = await axios.post(
        url,
        formData,
        {
          headers: { Token: token }
        }
      )
      return result.data
    } catch (error) {
      console.error("uploadFile error: ", error.response?.data.message)
    }
  },
  downloadFile(file) {
      const url = URL.createObjectURL(file);

      const a = document.createElement("a");
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(url);
  },
  async addServer(request){
    try {
      let {data, cidData} = request;
      const formData = new FormData()
      formData.append('data', data)
      formData.append('cidData', cidData)
      const token = await iStoreApi.getToken()
      let url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/addserver`
      const result = await axios.post(url, formData, {
        headers: {Token: token},
      })
      if (result.data) {
        return result.data
      }

    } catch (error) {
      console.error("addserver error: ", error.response?.data.message)
    }
    return {}
  },
  async createDB(request){
    try {
      let {newDbName, dbToken} = request;
      const result = await iStoreApi.createDB(newDbName, dbToken)
      if (result.data) {
        return result.data
      }

    } catch (error) {
      console.error("addserver error: ", error.response?.data.message)
    }
    return {}
  },
  setNotificationMsg(request) {
    try {
      let {data} = request
      if (data) {
        $store.commit('setNotificationMsg', data)
      }
    } catch (error) {
      console.error("setNotificationMsg error: ", error)
    }
  },
  // QI plugin
  async qiCreateFolder(request) {
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/createfolder`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        config
      )
      return result.data
    } catch (error) {
      console.error("qiCreateFolder error: ", error)
    }
    return {}
  },
  // QI plugin - create data (category or campaign)
  async qiCreateData(request) {
    try {
      let {requestData} = request
      console.log('[imanager3-appframe] qiCreateData - requestData received:', requestData)
      const url = `${iStoreSetting.iStoreUrl}/qa/createdata`
      console.log('[imanager3-appframe] qiCreateData - sending to:', url, 'data:', requestData)
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(url, requestData, config)
      return result.data
    } catch (error) {
      console.error("qiCreateData error: ", error)
    }
    return {}
  },
  // QI plugin
  async qiGetFolderContent(request) {
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/getfoldercontent`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        config
      )
      return result.data
    } catch (error) {
      console.error("qiGetFolderContent error: ", error)
    }
    return {}
  },
  // The equivalent of search() but for QI plugin
  async qiGetFile(request) {
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/getfile`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        {
          ...config,
          responseType: "blob"
        }
      )
      if (result.headers !== undefined) {
        if (result.headers["content-type"].includes("application/json")) {
          const resolved = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(result.data)
          })
          if (resolved) return JSON.parse(resolved)
        } else if (result.headers["content-type"].includes("text")) {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(result.data)
          })
        } else {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsDataURL(result.data)
          })
        }
      }
    } catch (error) {
      console.error("qiGetFile error: ", error)
    }
    return {}
  },
  // The equivalent of delete() but for QI plugin
  async qiDeleteFile(request) {
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/deletefile`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.delete(
        url,
        {
          ...config,
          data: iStoreUtils.jsonToFormData(formData)
        }
      )
      return result.data
    } catch (error) {
      console.error("qiDeleteFile error: ", error)
    }
    return {}
  },
  // The equivalent of update() but for QI plugin
  async qiUpdateFile(request) {
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/updatefile`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        config
      )
      return result.data
    } catch (error) {
      console.error("qiUpdateFile error: ", error)
    }
    return {}
  },
  // QI plugin
  async qiUploadFile(request) {
    try {
      let {formData} = request
      let parsedFormData = iStoreUtils.jsonToFormData(formData)
      let newFile
      const fetchFileByUrl = await fetch(parsedFormData.get("fileUrl"))
      if (fetchFileByUrl) {
        const response = await fetchFileByUrl.blob()
        newFile = new File([response], parsedFormData.get("fileName")) // Reconstruct the file
      }
      parsedFormData.delete("fileName")
      parsedFormData.delete("fileUrl")
      parsedFormData.append("file", newFile)
      const url = `${iStoreSetting.iStoreUrl}/qa/uploadfile`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        parsedFormData,
        config
      )
      if (result.status === 429) return {
        status: "error",
        code: 429,
        message: "Too many requests"
      }
      return result.data
    } catch (error) {
      console.error("qiUploadFile error: ", error)
    }
    return {}
  },
  // Qi upload inspected text file
  async qiUploadInspectedText(request) {
    try {
      let {formData} = request
      let parsedFormData = iStoreUtils.jsonToFormData(formData)
      let newFile
      const fetchFileByUrl = await fetch(parsedFormData.get("fileUrl"))
      if (fetchFileByUrl) {
        const response = await fetchFileByUrl.blob()
        newFile = new File([response], parsedFormData.get("fileName")) // Reconstruct the file
      }
      parsedFormData.delete("fileName")
      parsedFormData.delete("fileUrl")
      parsedFormData.append("file", newFile)
      const url = `${iStoreSetting.iStoreUrl}/qa/uploadinspectedtext`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        parsedFormData,
        config
      )
      if (result.status === 429) return {
        status: "error",
        code: 429,
        message: "Too many requests"
      }
      return result.data
    } catch (error) {
      console.error("qiUploadFile error: ", error)
    }
    return {}
  },
  // QI plugin
  async qiGetBasePath(request) {
    try {
      const params = request?.formData ?? {}
      const url = `${iStoreSetting.iStoreUrl}/qa/getbasepath`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.get(url, { params }, config)
      return result.data
    } catch (error) {
      console.error("qiGetBasePath error: ", error)
    }
    return {}
  },
  // QI plugin
  async qiGetEnv() {
    try {
      const url = `${iStoreSetting.iStoreUrl}/qa/getenv`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.get(url, config)
      return result.data
    } catch (error) {
      console.error("qiGetEnv error: ", error)
    }
    return {}
  },
  // QI plugin
  async qiSetEnv(request) {
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/setenv`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        config
      )
      return result.data
    } catch (error) {
      console.error("qiSetEnv error: ", error)
    }
    return {}
  },
  // QI plugin: as an API proxy, typically used for a server that doesn't support CORS
  // This supports API call without request body (like a GET)
  async qiGetApi(request) {
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/getapi`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        config
      )
      return result.data
    } catch (error) {
      console.error("qiGetApi error: ", error)
    }
    return {}
  },
  // QI plugin: as an API proxy, typically used for a server that doesn't support CORS
  // This supports API call with request body (like a POST)
  async qiPostApi(request) {
    try {
      let {requestData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/postapi`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(
        url,
        requestData,
        config
      )
      return result.data
    } catch (error) {
      console.error("qiPostApi error: ", error)
    }
    return {}
  },
  // QI download report
  async qiDownloadReport(request) {
    try {
      let { payload } = request

      const parsedPayload = JSON.parse(payload)
      const url = `${iStoreSetting.iStoreUrl}/qa/report/download`;
      const token = await iStoreApi.getToken()

      const response = await axios.post(url, parsedPayload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Token: token,
        },
        responseType: "blob"
      });
      if (response.headers) {
        const contentType = response.headers["content-type"] || "";

        // Case 1: Backend returned JSON (e.g., error response)
        if (contentType.includes("application/json")) {
          const resolved = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            reader.readAsText(response.data);
          });
          return JSON.parse(resolved);
        }

        // Case 2: Backend returned plain text (edge case)
        if (contentType.includes("text")) {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            reader.readAsText(response.data);
          });
        }

        // ✅ Case 3: Backend returned binary (PDF, etc.)
        return await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result); // base64 DataURL
          reader.onerror = () => reject(reader.error);
          reader.readAsDataURL(response.data);
        });
      }
    } catch (error) {
      console.error("qiDownloadReport error: ", error)
    }
    return {}
  },
  // QI download report (batch)
  async qiDownloadReportBatch(request) {
    try {
      let { payload } = request

      const parsedPayload = JSON.parse(payload)
      const url = `${iStoreSetting.iStoreUrl}/qa/report/download/batch`;
      const token = await iStoreApi.getToken()

      const response = await axios.post(url, parsedPayload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Token: token,
        },
        responseType: "blob"
      });
      if (response.headers) {
        const contentType = response.headers["content-type"] || "";

        // Case 1: Backend returned JSON (e.g., error response)
        if (contentType.includes("application/json")) {
          const resolved = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            reader.readAsText(response.data);
          });
          return JSON.parse(resolved);
        }

        // Case 2: Backend returned plain text (edge case)
        if (contentType.includes("text")) {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            reader.readAsText(response.data);
          });
        }

        // ✅ Case 3: Backend returned binary (ZIP)
        return await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result); // base64 DataURL
          reader.onerror = () => reject(reader.error);
          reader.readAsDataURL(response.data);
        });
      }
    } catch (error) {
      console.error("qiDownloadReportBatch error: ", error)
    }
    return {}
  },
  // QI get Report
  async qiGetReport() {
    try {
      const url = `${iStoreSetting.iStoreUrl}/qa/getReportDetail`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(url,config)
      return result.data
    } catch (error) {
      console.error("qiGetReport error: ", error)
    }
    return {}
  },
  // QI get files in folder
  async qiGetFilesinFolder(request) {
    try {
      let {folderPath} = request

      const formData = new FormData();
      formData.append("folderPath", folderPath);

      const url = `${iStoreSetting.iStoreUrl}/qa/getFilesinFolder`;
      const token = await iStoreApi.getToken()

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Token: token,
        },
      });
      if (response.data) {
        return response.data;
      } else {
        throw response.response.data.error
      }
    } catch (error) {
      console.error("qiGetFilesinFolder error: ", error)
    }
    return {}
  },
  // QI get all campaigns
  async qiGetCampaigns() {
    try {
      const url = `${iStoreSetting.iStoreUrl}/qa/getCampaigns`
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      const result = await axios.post(url,config)

      return result.data
    } catch (error) {
      console.error("getCampaigns error: ", error)
    }
  },
  // QI stt queue plugin
  async qiUploadFileSTTQueue(request) {
    try {
      let {formData} = request
      let parsedFormData = iStoreUtils.jsonToFormData(formData)
      let newFile
      const fetchFileByUrl = await fetch(parsedFormData.get("fileUrl"))
      if (fetchFileByUrl) {
        const response = await fetchFileByUrl.blob()
        newFile = new File([response], parsedFormData.get("fileName")) // Reconstruct the file
      }
      parsedFormData.delete("fileName")
      parsedFormData.delete("fileUrl")
      parsedFormData.append("file", newFile)
      const url = `${iStoreSetting.iStoreSTT}/qa/uploadfile`
      const result = await axios.post(
        url,
        parsedFormData
      )
      return result.data
    } catch (error) {
      console.error("qiUploadFile error: ", error)
    }
    return {}
  },
  // QI stt queue get file
  async qiGetFileSTTQueue(request){
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreSTT}/qa/getfile`
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        {
          responseType: "blob"
        }
      )
      if (result.headers !== undefined) {
        if (result.headers["content-type"].includes("application/json")) {
          const resolved = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(result.data)
          })
          if (resolved) return JSON.parse(resolved)
        } else if (result.headers["content-type"].includes("text")) {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(result.data)
          })
        } else {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsDataURL(result.data)
          })
        }
      }
    } catch (error) {
      console.error("qiGetFile error: ", error)
    }
    return {}
  },
  async _createFunction(functions) {
    const result = await iStoreApi.putBatch(this.iStoreUIDB, functions)
    if (result && result.status === 200) {
      for (const func of functions) {
        const funcNode = JSON.parse(func.value);

        // await this._syncLanguage(funcNode)
        $store.commit('removeNode', funcNode)
        $store.commit('addNode', funcNode)
      }
    }
    return result
  },
  _createToken(pluginId, pageId) {
    const token = iStoreUtils.uuid();

    let value = window.sessionStorage.getItem(this.imanagerPluginTokenKey);
    if (value) {
      value = iStoreUtils.decode(value)
      value = JSON.parse(value);

      let idx = value.length
      while (idx--) {
        let v = value[idx]
        if (v.pluginId === pluginId && v.pageId === pageId) {
          value.splice(idx, 1)
        }
      }
    } else {
      value = []
    }

    const data = {pluginId, pageId, token, _rn: new Date().getMilliseconds()}
    value.push(data)


    value = iStoreUtils.encode(JSON.stringify(value))

    // Keep page session
    window.sessionStorage.setItem(this.imanagerPluginTokenKey, value)

    return iStoreUtils.encode(JSON.stringify(data))
  },
  _checkToken(token) {
    let value = window.sessionStorage.getItem(this.imanagerPluginTokenKey)
    if (value) {
      value = JSON.parse(iStoreUtils.decode(value));


      if (value && value.length) {
        for (let v of value) {
          if (v.token === token) {
            return v
          }
        }
      }
    }
  },
  camelCaseToTitle(str) {
    return str
      .replace(/([A-Z])/g, ' $1')     // insert space before capital letters
      .replace(/^./, (s) => s.toUpperCase()); // capitalize the first character
  },
  async _syncLanguage(data) {
    const languages = []

    // Delete all old language keys
    const result = await iStoreApi.deleteBatch(
      'language',
      `language.${data.module}.${data.name}`
    )
    if (result && result.data.result === '200') {
      console.log("#[AppFrame] Successfully removed old language keys")
    } else {
      console.warn("#[AppFrame] Problem when removing old language keys")
    }

    if (data.displayName && data.displayName.trim() !== '') {
      const key = `${data.module}.${data.name}`
      const value = data.displayName.trim()
      languages.push({key, value})
    }
    if (data.columns) {
      for (let column of data.columns) {
        if (column.displayName && column.displayName.trim() !== '') {
          const key = `${data.module}.${data.name}.column.${column.name}`
          const value = column.displayName.trim()
          languages.push({key, value})
        }
      }
    }

    let parents = (data.parent ?? '').split(".")
    if (parents.length) {
      for (let index = 0; index < parents.length; index++) {
        const parent = parents[index];
        var parentValue = parent
        const key = `folder.level${index}.${parent}`
        if (parent == "concioSystem") {
          parentValue = "OneConsole System"
        }
        else if (parent == "systemPlugin") {
          parentValue = "OneConsole Plugin"
        }
        else if (parent == "system") {
          parentValue = "OneConsole Admin"
        }
        else{
          parentValue = this.camelCaseToTitle(parent)
        }
        languages.push({key, value: parentValue})
        const result = await iStoreApi.delete(
          'language',
          `language.${key}`
        )
        if (result && result.data.result === '200') {
          console.debug("#[AppFrame] Successfully removed old language key:", key)
        } else {
          console.warn("#[AppFrame] Problem when removing old language key:", key)
        }
      }
    }
    console.debug("#[AppFrame] Update Language:", JSON.stringify(languages, null, 2))

    langControl.syncDatabase(languages).finally()
  },
  async onMessage(evt, callBy) {
    const request = evt.data
    if (request.type?.includes("webpack")) {
      return
    }
    console.log('#[AppFrame] RECV: %O, callBy:%s', request, callBy)

    $store.commit("resetActivityTimeout")

    let action, plugin
    if (typeof request === 'string') {
      action = request
    } else if (typeof request === 'object') {
      if ('register' !== request.action) {

        action = request.action
        // if (!request.pluginId) {
        //   console.error('#[AppFrame] pluginId not found!, REQ:', request)
        //   return;
        // }
        // if (!request.pageId) {
        //   console.error('#[AppFrame] pageId not found!, REQ:', request)
        //   return;
        // }
        if (!request.token) {
          console.error('#[AppFrame] token not found!, REQ:', request)
          return;
        }

        // Get page session
        plugin = this._checkToken(request.token)

        if (!plugin) {
          console.error('#[AppFrame] Token invalid!, REQ:', request)
          return;
        }

        console.debug('#[AppFrame] Plugin:', plugin)
      } else {
        action = request.action
      }
    }
    console.info('#[AppFrame] Action:', action)

    try {
      if (action) {
        let result = await this[action](request, plugin);
        if (!(result === undefined || result === null)) {
          const data = {
            action,
            result,
            messageId: request.messageId ?? ""
          }
          console.debug('#[AppFrame] result:', data)
          let appFrame = document.getElementById('appFrame')
          if (appFrame) {
            appFrame.contentWindow.postMessage(JSON.stringify(data), '*')
          } else {
            // For instance initialization upon "loginNotify"
            document.getElementById(`loginNotify-${request.pluginId}`).contentWindow.postMessage(JSON.stringify(data), '*')
          }
        }
      } else {
        console.error('#[AppFrame] No action specified from plugin!')
      }
    } catch (e) {
      console.error('#[AppFrame] exec action fail!, action:%s, plugin:%O, error:%s', action, plugin, e)
    }
  },
  async generateKey(request){
    try {
      let {data} = request
      
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      let url
      if (data !== null) {

        url = `${iStoreSetting.iStoreUrl}/indexserver/local/license/generate`
        const result = await axios.post(url, data, config)
        return result.data
        } else {
          console.error("data is null")
          return null
        }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async validateKey(request){
    try {
      let {data} = request
      
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      let url
      if (data !== null) {

      url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/license/validate`
      const result = await axios.post(url, data, config)
      return result.data
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async issueOrderQr(request) {
    try {
      let {data} = request
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      if (data !== null) {
        const url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/order/issue`
        const result = await axios.post(url, data, config)
        return result.data
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async createConcioUser(request){
    try {
      let {data} = request
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }

      let url
      if (data !== null) {

        url = `${iStoreSetting.iStoreUrl}/concio/account/create`
        const result = await axios.post(url, data, config)
        return result.data
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async updateConcioUser(request){
    try {
      let {data} = request
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }

      let url
      if (data !== null) {

        url = `${iStoreSetting.iStoreUrl}/concio/account/update`
        const result = await axios.post(url, data, config)
        return result.data
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async deleteConcioUser(request){
    try {
      let {data} = request
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }

      let url
      if (data !== null) {

        url = `${iStoreSetting.iStoreUrl}/concio/account/delete`
        config.data = data
        const result = await axios.delete(url, config)
        return result.data
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async deleteConcioUserBatch(request){
    try {
      let {datas} = request
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }

      let url
      if (datas !== null) {

        url = `${iStoreSetting.iStoreUrl}/concio/account/delete/batch`
        config.data = datas
        const result = await axios.delete(url, config)
        return result.data
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async resetConcioPassword(request){
    try {
      let {data} = request
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }

      let url
      if (data !== null) {

        url = `${iStoreSetting.iStoreUrl}/concio/account/resetpassword`
        const result = await axios.post(url, data, config)
        return result.data
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async getStarNumberAvailability(request){
    try {
      let {prefix, length, from, to, limit} = request
      const token = await iStoreApi.getTokenCloud()
      const config = {
        headers: {
          Token: token,
        },
      }

      let url
      if (prefix !== null) {

        const params = []
        if (length) params.push(`length=${length}`)
        if (from !== undefined && from !== null) params.push(`from=${from}`)
        if (to !== undefined && to !== null) params.push(`to=${to}`)
        if (limit !== undefined && limit !== null) params.push(`limit=${limit}`)
        const query = params.length ? `?${params.join("&")}` : ""
        url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/starnumbers/availability/${prefix}${query}`
        const result = await axios.get(url, config)
        if (result.data) {
          return result
        }
        else{
          return null
        }
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async getStarNumberSummary(){
    try {
      const token = await iStoreApi.getTokenCloud()
      const config = {
        headers: {
          Token: token,
        },
      }
      const url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/starnumbers/summary`
      const result = await axios.get(url, config)
      return result?.data ? result : null
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async backfillStarNumbers(){
    try {
      const token = await iStoreApi.getTokenCloud()
      const config = {
        headers: {
          Token: token,
        },
      }
      const url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/starnumbers/backfill`
      const result = await axios.post(url, {}, config)
      return result?.data ? result : null
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async getStarNumberCustomerAvailability(request){
    try {
      let {custID} = request
      const token = await iStoreApi.getTokenCloud()
      const config = {
        headers: {
          Token: token,
        },
      }

      let url
      if (custID !== null) {

        url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/starnumbers/availability/customer/${custID}`
        const result = await axios.get(url, config)
        if (result.data) {
          return result
        }
        else{
          return null
        }
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async rearrangeStarNumberRange(request){
    try {
      let {data} = request
      const token = await iStoreApi.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }

      let url
      if (data !== null) {

        url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/rearrange`
        const result = await axios.post(url, data, config)
        return result.data
      } else {
        console.error("data is null")
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async getCampaignTree(request){
    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/getCampaignTree`
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        {
          responseType: "blob"
        }
      )
      // return result

      if (result.headers !== undefined) {
        if (result.headers["content-type"].includes("application/json")) {
          const resolved = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(result.data)
          })
          if (resolved) return JSON.parse(resolved)
        } else if (result.headers["content-type"].includes("text")) {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(result.data)
          })
        } else {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsDataURL(result.data)
          })
        }
      }
    } catch (error) {
      console.error("getCampaignTree error: ", error)
    }
    return {}
  },
  async copyCampaign(request){

    try {
      let {formData} = request
      const url = `${iStoreSetting.iStoreUrl}/qa/copyCampaign`
      const result = await axios.post(
        url,
        iStoreUtils.jsonToFormData(formData),
        {
          responseType: "blob"
        }
      )
      // return result

      if (result.headers !== undefined) {
        if (result.headers["content-type"].includes("application/json")) {
          const resolved = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(result.data)
          })
          if (resolved) return JSON.parse(resolved)
        } else if (result.headers["content-type"].includes("text")) {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(result.data)
          })
        } else {
          return await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = () => reject(reader.error)
            reader.readAsDataURL(result.data)
          })
        }
      }
    } catch (error) {
      console.error("copyCampaign error: ", error)
    }
    return {}
  }
}
